import * as React from 'react';
import { Box } from '@mui/system';
import type { EmblaOptionsType } from 'embla-carousel';
import useEmblaCarousel from 'embla-carousel-react';

interface Props {
  activeSlide: number;
  dataCy?: string;
  children: React.ReactNode[];
}

export const Carousel: React.FC<Props> = (props) => {
  const options: EmblaOptionsType = {
    startIndex: props.activeSlide
  };
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  React.useEffect(() => {
    if (emblaApi) {
      emblaApi.scrollTo(props.activeSlide, false);
    }
  }, [props.activeSlide]);

  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'hidden',
        animation: 'translate3d 0.2s ease',
        '& .embla__container': {
          touchAction: 'pan-y',
          display: 'flex'
        },
        '& .embla__slide': {
          flex: '0 0 100%',
          minWidth: '0'
        }
      }}
    >
      <Box sx={{ display: 'flex' }}>
        <Box className="embla__viewport" ref={emblaRef}>
          <Box className="embla__container">
            {props.children.map((child, index) => (
              <Box className="embla__slide" key={index}>
                <Box className="embla__slide__number">{child}</Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
